import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';

import { classes } from '~utils/ClassNames';
import CartItem from './CartItem/CartItem';

import ICartSidebarItems from './ICartSidebarItems';

import useModal from '~sharedComponents/Modal/useModal';
import { ReplenishmentTooltipModalContext } from '~views/ShoppingBagTab/CartSidebarItems/CartItem/ReplenishmentComponent/ReplenishmentTooltipModalContext/ReplenishmentTooltipModalContext';
import { ReplenishmentTooltipModal } from '~views/ShoppingBagTab/CartSidebarItems/CartItem/ReplenishmentComponent/ReplenishmentTooltipModal/ReplenishmentTooltipModal';

const ItemsContainer = styled.div`
    flex-grow: 1;
`;

const ItemsList = styled.div`
    width: 100%;
`;

const cartOverlaySidebarItemsClass = classes('cart-sidebar-sidebar-items');

const CartSidebarItems: React.FC<ICartSidebarItems> = observer(
    ({ cartItems, onRemoveItem, onQuantitySelect, config, translations }) => {
        const replenishmentTooltipModalProps = useModal();

        return (
            <ReplenishmentTooltipModalContext.Provider value={replenishmentTooltipModalProps}>
                <ItemsContainer className={cartOverlaySidebarItemsClass}>
                    <ItemsList>
                        {cartItems.map((item) => (
                            <CartItem
                                key={item.skuId}
                                cartItem={item}
                                config={config}
                                onRemoveItem={onRemoveItem}
                                translations={translations}
                                onQuantitySelect={onQuantitySelect}
                            />
                        ))}
                    </ItemsList>
                </ItemsContainer>
                <ReplenishmentTooltipModalContext.Consumer>
                    {() => <ReplenishmentTooltipModal />}
                </ReplenishmentTooltipModalContext.Consumer>
            </ReplenishmentTooltipModalContext.Provider>
        );
    }
);

export default CartSidebarItems;
